import {
  Box,
  Card,
  CardContent,
  LinearProgress,
  MenuItem,
  Skeleton,
  Typography,
  Popover,
  Button,
  ClickAwayListener,
  Menu
} from '@mui/material';
import {
  keywordOverviewCss,
  KeywordOverviewResultCardsCss
} from '../keywordResearch/keywordOverview/keywordOverviewCSS';
import { Fragment, lazy, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { broadcastService } from 'src/common/services/broadcastService';
import { keywordResearchDashBoardCss } from '../keywordResearch/keywordResearchCSS';
import { KeywordTrackingResultCss } from '../keywordResearch/keywordTracking/KeywordTrackingAllCss';
import { CustomTooltip } from '../keywordResearch/CustomTooltip';
import HelpIcon from '@mui/icons-material/Help';
import { Area, AreaChart, ResponsiveContainer, Tooltip } from 'recharts';
import { dataGraphsCss, newCardsCss } from '../dashboard/DashboardCss';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { locationMetrics } from 'src/common/Scraper';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { LocalSeoAllSx, TimeLineDropdownSx } from './localSeoCss';
import {
  getCookie,
  localStorageMethod,
  openNewTab
} from 'src/common/config/FunctionHelper';
import {
  disconnectedModalTexts,
  enterpriseDropdownBusinessesLimit,
  localSeoSignupSourceSqsp,
  localseoSignupSqspFlow,
  paths
} from 'src/common/config/TextMessage';
import { setLocalSeoSection } from 'src/redux/keywordResearch';
import {
  setIsLocalSeoExtResultAccessed,
  setIsProfileDeleted,
  setIsProfileDeletedUpdate,
  setSelectedAccountId,
  setSelectedBusinessName,
  setSelectedBusinessNameFilter,
  setSelectedLocationId,
  setSelectedTimelineFilter
} from 'src/redux/localSeo';
import {
  getLocalSeoBusinessId,
  getLocalSeoId,
  removeLocalSeoSqSpData,
  removeNegativeSign,
  setLocalSeoBusinessId,
  setLocalSeoId
} from 'src/common/config/FunctionHelperPartTwo';
import { websiteAuditAfterLinearBar } from '../siteAudit/siteAuditCSS';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { useNavigate } from 'react-router';
import { localSeoTexts } from './localSeoTexts';
import Loader from 'src/common/config/Loader';
const DeleteProfileModal = Loader(
  lazy(() =>
    import('./DeleteProfileModal').then((module) => ({
      default: module.DeleteProfileModal
    }))
  )
);
const LocalSeoCommonLoader = Loader(
  lazy(() =>
    import('./LocalSeoCommonLoader').then((module) => ({
      default: module.LocalSeoCommonLoader
    }))
  )
);
const LocalSeoMapDashBoard = Loader(
  lazy(() =>
    import('./LocalSeoMapDashBoard').then((module) => ({
      default: module.LocalSeoMapDashBoard
    }))
  )
);
const TrackingFrequency = Loader(
  lazy(() =>
    import('./TrackingFrequency').then((module) => ({
      default: module.TrackingFrequency
    }))
  )
);

const BuySlotsCommonModal = Loader(
  lazy(() => import('src/common/LocalSeoCommonComponents/BuySlotsCommonModal'))
);
const CommonModal = Loader(lazy(() => import('src/common/config/CommonModal')));
import { BusinessProfileSelector } from './BusinessProfileSelector';
import { DisconnectedModal } from 'src/common/DisconnectedModal';
import DateRangeButton, {
  DateRangeButtonProps
} from 'src/components/UI/DateRangeButton';
import { startOfDay, subDays } from 'date-fns';
import dayjs from 'dayjs';
import { useUserDateFormat } from 'src/hooks/useUserDateFormat';

interface IGetLocationMetrics {
  id: string;
  accountId: string;
  startDate: Date | null;
  endDate: Date | null;
}

export const YourPerformanceCard = ({
  locationsData,
  isExporting = false,
  isPdfBuilder = false
}) => {
  const { userDateFormat } = useUserDateFormat();

  // ── Declare localSeoReportData FIRST so getInitialMetrics can safely close over it ──
  // Moving this selector to the top of the component prevents a Temporal Dead Zone
  // (TDZ) error: "Cannot access 'localSeoReportData' before initialization".
  // The variable was previously declared at line ~174, after getInitialMetrics() was
  // already called at line ~116, causing a crash in React strict mode.
  const localSeoReportData = useSelector(
    (state: RootState) => state.dashboard.localSeoReportData
  );

  // Helper to compute metrics from Redux data (consolidated from dashboard slice)
  const getInitialMetrics = () => {
    if (localSeoReportData?.metrics) {
      const metrics = localSeoReportData.metrics;
      const dailyMetrics = metrics.locationMetrics?.dailyMetrics || [];
      return {
        avgRatingCardData: metrics.reviewsDetails || [],
        allCardData: metrics.locationMetrics?.totals || {},
        allChangesData: metrics.locationMetrics?.percentChange || {},
        callsGraphData: dailyMetrics.map((item) => ({
          clicks: item?.TotalCalls
        })),
        directionGraphData: dailyMetrics.map((item) => ({
          clicks: item?.BusinessDirectionRequest
        })),
        clicksGraphData: dailyMetrics.map((item) => ({
          clicks: item?.WebsiteClicks
        })),
        totalReviewsCount: metrics.totalReviewsCount,
        totalReviewsRating: metrics.totalReviewsRating,
        cardLoader: false,
        cardReviewLoader: false
      };
    }
    return {
      avgRatingCardData: [],
      allCardData: [],
      allChangesData: [],
      callsGraphData: [],
      directionGraphData: [],
      clicksGraphData: [],
      totalReviewsCount: null,
      totalReviewsRating: null,
      cardLoader: true,
      cardReviewLoader: true
    };
  };

  const initialMetrics = getInitialMetrics();

  const [avgRatingCardData, setAvgRatingCardData]: any = useState(
    initialMetrics.avgRatingCardData
  );
  const [allCardData, setAllCardData]: any = useState(
    initialMetrics.allCardData
  );
  const [allChangesData, setAllChangesData]: any = useState(
    initialMetrics.allChangesData
  );
  const [callsGraphData, setCallsGraphData]: any = useState(
    initialMetrics.callsGraphData
  );
  const [directionGraphData, setDirectionGraphData]: any = useState(
    initialMetrics.directionGraphData
  );
  const [clicksGraphData, setClicksGraphData]: any = useState(
    initialMetrics.clicksGraphData
  );
  const [cardLoader, setCardLoader]: any = useState(initialMetrics.cardLoader);
  const [totalReviewsRating, setTotalReviewsRating]: any = useState(
    initialMetrics.totalReviewsRating
  );
  const [totalReviewsCount, setTotalReviewsCount]: any = useState(
    initialMetrics.totalReviewsCount
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const [googleAuth, setGoogleAuth]: any = useState(null);
  const monthOptions: DateRangeButtonProps['presets'] = [
    { label: 'Past 7 Days', value: 7 },
    { label: 'Last 28 days', value: 28 },
    { label: 'Last 3 months', value: 90 },
    { label: 'Last 12 months', value: 365 }
  ];

  const [selectedDates, setSelectedDates] = useState<{
    startDate: Date;
    endDate: Date;
  }>(() => {
    const defaultDates = getPresetRange(monthOptions[0].value);
    return {
      startDate: defaultDates.start,
      endDate: defaultDates.end
    };
  });

  const [openMonitoringModal, setOpenMonitoringModal]: any = useState(false);
  const [isMap, setIsMap]: any = useState(null);
  const [anchorElMore, setAnchorElMore]: any = useState(null);
  const [isDropdownOpen, setIsDropdownOpen]: any = useState(null);
  const [openDeleteProfileModal, setOpenDeleteProfileModal]: any =
    useState(false);
  const [showBuyLocalSeoSlot, setShowBuyLocalSeoSlot] = useState(null);

  const [cardReviewLoader, setReviewCardLoader]: any = useState(
    initialMetrics.cardReviewLoader
  );
  const [isProgressing, setIsProgressing]: any = useState(null);
  const [openDisconnectedModal, setOpenDisconnectedModal] = useState(false);
  const showLocalMap: any =
    useSelector((state: RootState) => state.localSeo.showLocalMap) ?? null;
  let selectedBusinessName: any =
    useSelector((state: RootState) => state.localSeo.selectedBusinessName) ??
    '';
  let businessNamesData: any =
    useSelector((state: RootState) => state.localSeo.businessNamesData) ?? [];
  let reduxFilteredLocationsData: any =
    useSelector(
      (state: RootState) => state.localSeo.reduxFilteredLocationsData
    ) ?? null;
  let userDetails: any = useSelector(
    (state: RootState) => state.counter.userDetails
  );
  const match = reduxFilteredLocationsData?.find(
    (location) => location?.title === selectedBusinessName
  );
  const localStorageSeoId = getLocalSeoId();
  const refreshMatch = reduxFilteredLocationsData?.find(
    (location) =>
      location?.name === localStorageSeoId && location?.temp !== true
  );
  let localSeoSection: any = useSelector(
    (state: RootState) => state.keywordResearch.localSeoSection
  );
  const [selectedAddress, setSelectedAddress]: any = useState(
    //refreshMatch || match || reduxFilteredLocationsData?.[0] || ''
    ''
  );

  // useEffect to set when redux data arrives
  useEffect(() => {
    if (!reduxFilteredLocationsData || reduxFilteredLocationsData?.length === 0)
      return;

    const refreshMatch = reduxFilteredLocationsData.find(
      (location) =>
        location?.name === localStorageSeoId && location?.temp !== true
    );

    setSelectedAddress(
      refreshMatch || match || reduxFilteredLocationsData?.[0] || ''
    );
  }, [reduxFilteredLocationsData, localStorageSeoId, match, refreshMatch]); // run when any of these change

  const [selectedMonth, setSelectedMonth]: any = useState(null);
  const dispatch = useDispatch();
  let selectedLocationId: any = useSelector(
    (state: RootState) => state.localSeo.selectedLocationId
  );
  const cleanedLocationId = selectedLocationId?.replace('locations/', '');
  let selectedAccountId: any = useSelector(
    (state: RootState) => state.localSeo.selectedAccountId
  );
  let isProfileDeleted: any =
    useSelector((state: RootState) => state.localSeo.isProfileDeleted) ?? null;
  const isLocalSeoExtResultAccessed = useSelector(
    (state: RootState) => state.localSeo.isLocalSeoExtResultAccessed
  );
  const locationListResponse =
    useSelector((state: RootState) => state.localSeo.locationListResponse) ??
    false;
  let activePlanName = useSelector((state: RootState) => state.user.activePlan);
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  const isEnterprise = activePlanName === planDetails?.enterprise;

  const [squarespaceDisconnected, setSquarespaceDisconnected] = useState(null);
  const [disableDisconnectPopup, setDisableDisconnectPopup] = useState(null);
  const monthBoxRef = useRef(null);
  const businessRef = useRef(null);

  const openMore = Boolean(anchorElMore);
  const navigate = useNavigate();
  const locationStoredId = getLocalSeoId();
  const locationStoredBusinessId = getLocalSeoBusinessId();
  const cleanedStoredLocationId = locationStoredId?.replace('locations/', '');
  const getLocalSeoCookieSqsp = getCookie(localseoSignupSqspFlow) ?? null;
  const isLocalSeoSqsp = getLocalSeoCookieSqsp === localSeoSignupSourceSqsp;
  const squareSpaceSite = localStorageMethod('get', 'squareSpaceSite');
  let doNotShowDisconnect = localStorageMethod(
    'get',
    'do_not_show_local_seo_disconnect'
  );
  const doNotShowAgain = doNotShowDisconnect == 'true';
  useEffect(() => {
    broadcastService.subscribe('your-performance-card', {
      'gbpc_auth_connection': (data) => {
        setGoogleAuth(data);
      }
    });
    return () => broadcastService.unsubscribe('your-performance-card');
  }, []);

  useEffect(() => {
    setIsProgressing(selectedAddress?.progressing);
  }, [selectedAddress]);

  useEffect(() => {
    setIsMap(showLocalMap);
  }, [showLocalMap]);

  useEffect(() => {
    if (!selectedMonth && monthOptions) {
      setSelectedMonth(monthOptions[0]);
      // dispatch(setSelectedTimelineFilter(monthOptions[0]));
    }
  }, [monthOptions]);

  useEffect(() => {
    if (googleAuth?.message && googleAuth?.success) {
      dispatch(setLocalSeoSection(0));
      setGoogleAuth(null);
    }
  }, [googleAuth]);
  useEffect(() => {
    dispatch(
      setSelectedBusinessNameFilter(match || businessNamesData[0] || '')
    );
    if (localSeoReportData?.metrics) {
      const metrics = localSeoReportData.metrics;
      const dailyMetrics = metrics.locationMetrics?.dailyMetrics || [];

      setAvgRatingCardData(metrics.reviewsDetails || []);
      setAllCardData(metrics.locationMetrics?.totals || {});
      setAllChangesData(metrics.locationMetrics?.percentChange || {});
      setCallsGraphData(
        dailyMetrics.map((item) => ({ clicks: item?.TotalCalls }))
      );
      setDirectionGraphData(
        dailyMetrics.map((item) => ({ clicks: item?.BusinessDirectionRequest }))
      );
      setClicksGraphData(
        dailyMetrics.map((item) => ({ clicks: item?.WebsiteClicks }))
      );
      setTotalReviewsCount(metrics.totalReviewsCount);
      setTotalReviewsRating(metrics.totalReviewsRating);
      setCardLoader(false);
      setReviewCardLoader(false);
    } else if (!isExporting && !isPdfBuilder) {
      getLocationMetrics({
        id: '',
        accountId: '',
        startDate: selectedDates.startDate,
        endDate: selectedDates.endDate
      });
    }
  }, [localSeoReportData]);

  useEffect(() => {
    (async () => {
      if (isProfileDeleted) {
        dispatch(setIsProfileDeleted(null));
        if (!isExporting) {
          await getLocationMetrics({
            id: '',
            accountId: '',
            startDate: selectedDates.startDate,
            endDate: selectedDates.endDate
          });
        }
        dispatch(setIsProfileDeletedUpdate(true));
      }
    })();
    return () => {};
  }, [isProfileDeleted]);

  useEffect(() => {
    if (
      squarespaceDisconnected === true &&
      !squareSpaceSite &&
      localSeoSection == 2 &&
      !disableDisconnectPopup
    ) {
      setOpenDisconnectedModal(true);
    }
  }, [squarespaceDisconnected]);

  useEffect(() => {
    try {
      // Safely check if any item has isConnectedWithSqsp === true
      const hasConnectedLocation = Array.isArray(reduxFilteredLocationsData)
        ? reduxFilteredLocationsData?.some(
            (item) => item?.isConnectedWithSqsp === true
          )
        : false;

      // Example: if you want to store this in state or do something with it
      // setIsConnected(hasConnectedLocation);

      // Trigger only if needed
      if (
        !isProgressing &&
        !isLocalSeoExtResultAccessed &&
        hasConnectedLocation &&
        userDetails?.isLocalSeo
      ) {
        dispatch(setIsLocalSeoExtResultAccessed(true));
      }
    } catch (error) {}
  }, [
    reduxFilteredLocationsData, // required to detect changes
    isProgressing,
    isLocalSeoExtResultAccessed
  ]);

  const getLocationMetrics = async ({
    id = '',
    accountId = '',
    startDate = null,
    endDate = null
  }: IGetLocationMetrics) => {
    // In PDF builder (preview or export), data is pre-fetched via getLocalSeoReportData.
    // Never call locationMetrics from the PDF builder context.
    if (isExporting || isPdfBuilder) {
      return;
    }
    if (isProgressing || localSeoReportData?.metrics) {
      return;
    }
    setReviewCardLoader(true);
    setCardLoader(true);
    const payload = {
      locationId: id ? id : cleanedLocationId ?? cleanedStoredLocationId,
      accountId: accountId
        ? accountId
        : selectedAccountId ?? locationStoredBusinessId,
      startDate: dayjs(startDate).format('YYYY-MM-DD'),
      endDate: dayjs(endDate).format('YYYY-MM-DD'),
      doNotShowAgain
    };
    const locationMetricsResponse: any = await locationMetrics(payload);
    if (locationMetricsResponse?.status === 'success') {
      const dailyMetrics =
        locationMetricsResponse?.locationMetrics?.dailyMetrics || [];

      const directionRequests = dailyMetrics?.map((item) => ({
        clicks: item.BusinessDirectionRequest
      }));

      const totalCalls = dailyMetrics?.map((item) => ({
        clicks: item?.TotalCalls
      }));

      const websiteClicks = dailyMetrics?.map((item) => ({
        clicks: item?.WebsiteClicks
      }));
      setAvgRatingCardData(locationMetricsResponse?.reviewsDetails);
      setAllCardData(locationMetricsResponse?.locationMetrics?.totals);
      setAllChangesData(
        locationMetricsResponse?.locationMetrics?.percentChange
      );
      setCallsGraphData(totalCalls);
      setDirectionGraphData(directionRequests);
      setClicksGraphData(websiteClicks);
      setTotalReviewsCount(locationMetricsResponse?.totalReviewsCount);
      setTotalReviewsRating(locationMetricsResponse?.totalReviewsRating);
      setSquarespaceDisconnected(
        locationMetricsResponse?.squarespace_disconnected
      );
      setDisableDisconnectPopup(
        locationMetricsResponse?.disable_disconnect_popup
      );
    }
    if (isLocalSeoSqsp) {
      removeLocalSeoSqSpData();
    }
    setCardLoader(false);
  };
  const getTrendColors = (diff: any) => {
    const isNegative = parseFloat(diff) < 0;
    return {
      stroke: isNegative ? '#F45251' : '#25D3B1',
      stop1: isNegative ? 'rgba(244, 82, 81, 1)' : '#25D3B1',
      stop2: isNegative ? 'rgba(244, 82, 81, 0)' : 'rgba(37, 211, 177, 0)',
      trendClass: isNegative ? 'negative-trend' : ''
    };
  };
  const dropdownSx = {
    minHeight: 44,
    gap: '8px',
    pt: '12px',
    pr: '16px',
    pb: '12px',
    pl: '16px',
    borderRadius: '6px',
    border: '1px solid #CCCCCC', // or your theme border
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0%',
    color: '#120242',
    '& .MuiSelect-select': {
      padding: 0
    }
  };

  let menuItemSx = {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 400,
    color: '#344054',
    paddingY: '8px',
    paddingX: '16px'
  };

  // Ensure totalReviews is a valid number (fallback to 0 if undefined/null)
  const totalReviews = totalReviewsCount || 0;

  // Initialize and calculate counts for each star rating
  const ratingCounts = avgRatingCardData?.reduce(
    (acc, curr) => {
      const rating = curr?.starRating;
      // Increment the count if the rating key exists in our accumulator
      if (rating && acc[rating] !== undefined) {
        acc[rating]++;
      }
      return acc;
    },
    {
      FIVE: 0,
      FOUR: 0,
      THREE: 0,
      TWO: 0,
      ONE: 0
    }
  ) || {
    FIVE: 0,
    FOUR: 0,
    THREE: 0,
    TWO: 0,
    ONE: 0
  }; // Fallback in case avgRatingCardData.reviews is null/undefined

  // Prepare final data for UI - safe from divide-by-zero by checking totalReviews
  const ratingData = [
    {
      value: '5 Stars',
      per: totalReviews
        ? `${Math.round((ratingCounts.FIVE / totalReviews) * 100)}%`
        : '0%'
    },
    {
      value: '4 Stars',
      per: totalReviews
        ? `${Math.round((ratingCounts.FOUR / totalReviews) * 100)}%`
        : '0%'
    },
    {
      value: '3 Stars',
      per: totalReviews
        ? `${Math.round((ratingCounts.THREE / totalReviews) * 100)}%`
        : '0%'
    },
    {
      value: '2 Stars',
      per: totalReviews
        ? `${Math.round((ratingCounts.TWO / totalReviews) * 100)}%`
        : '0%'
    },
    {
      value: '1 Star',
      per: totalReviews
        ? `${Math.round((ratingCounts.ONE / totalReviews) * 100)}%`
        : '0%'
    }
  ];

  const open = Boolean(anchorEl);

  const handleToggle = (event) => {
    setAnchorEl(open ? null : event.currentTarget);
  };

  const handleSelect = (locationObj) => {
    setSelectedAddress(locationObj); // store the full object
    dispatch(setSelectedBusinessNameFilter(locationObj?.title));
    dispatch(setSelectedBusinessName(locationObj?.title));
    const matchedName = locationObj?.name || null;
    const matchedAccountId = locationObj?.accountId || null;
    setLocalSeoId(matchedName);
    setLocalSeoBusinessId(matchedAccountId);
    dispatch(setSelectedLocationId(matchedName));
    dispatch(setSelectedAccountId(matchedAccountId));

    const cleanedId = matchedName?.replace('locations/', '');
    setAnchorEl(null);
    setSelectedMonth(monthOptions[0]);
    // dispatch(setSelectedTimelineFilter(monthOptions[0]));
    const defaultDates = getPresetRange(monthOptions[0].value);
    getLocationMetrics({
      id: cleanedId,
      accountId: matchedAccountId,
      startDate: defaultDates.start,
      endDate: defaultDates.end
    });
  };

  const handleMonthChange = (startDate: Date, endDate: Date) => {
    setSelectedDates({
      startDate,
      endDate
    });

    const matchedLocation = locationsData.find(
      (location) => location.title === selectedAddress
    );

    const matchedName = matchedLocation?.name || null;

    const cleanedId = matchedName?.replace('locations/', '');
    getLocationMetrics({
      id: cleanedLocationId,
      accountId: selectedAccountId,
      startDate,
      endDate
    });
  };

  const handleMonthSelect = (month) => {
    // handleMonthChange(month); // use existing handler
  };

  const getCompareScoreJSX = (comparisonScore) => {
    if (
      comparisonScore === 0 ||
      isNaN(comparisonScore) ||
      comparisonScore === null
    ) {
      return null;
    }
    if (Math.sign(comparisonScore) === 1) {
      return (
        <Box
          sx={{
            //marginTop: '38px',
            marginBottom: '12px',
            ...newCardsCss?.newIconBoxCss
          }}
        >
          <img src="/static/images/icons/local-seo/green_up.svg" alt="icon" />
          <Typography
            sx={{
              ...LocalSeoAllSx?.perSx,
              fontSize: '16px',
              color: '#1A927B'
            }}
          >
            {removeNegativeSign(comparisonScore)}%
          </Typography>
        </Box>
      );
    } else if (Math.sign(comparisonScore) === -1) {
      return (
        <Box
          sx={{
            //marginTop: '38px',
            marginBottom: '12px',
            ...newCardsCss?.newIconBoxCss
          }}
        >
          <img src="/static/images/icons/local-seo/red_down.svg" alt="icon" />
          <Typography
            sx={{
              ...LocalSeoAllSx?.perSx,
              fontSize: '16px',
              color: '#D92D20'
            }}
          >
            {removeNegativeSign(comparisonScore)}%
          </Typography>
        </Box>
      );
    }
  };

  const handleCloseMonitoringModal = () => {
    setOpenMonitoringModal(false);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMore(event.currentTarget);
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleClose = () => {
    setAnchorElMore(null);
  };

  const handleCloseDeleteProfileModal = () => {
    setOpenDeleteProfileModal(false);
  };

  const handleCloseDisconnectSiteModal = async () => {
    setOpenDisconnectedModal(false);
  };

  function getPresetRange(preset: number | string): { start: Date; end: Date } {
    const today = startOfDay(new Date());
    if (preset === 'custom_date') {
      return {
        start: selectedDates.startDate,
        end: selectedDates.endDate
      };
    }

    return {
      start: subDays(today, typeof preset === 'number' ? preset - 1 : 0),
      end: today
    };
  }

  const applyFilters = (startDate: Date, endDate: Date, preset: string) => {
    if (preset === 'custom_date') {
      setSelectedMonth(() => {
        return {
          label: `${dayjs(startDate).format(userDateFormat)} - ${dayjs(
            endDate
          ).format(userDateFormat)}`,
          value: 'custom_date'
        };
      });
      handleMonthChange(startDate, endDate);
      return;
    }

    handleMonthChange(startDate, endDate);
    setSelectedMonth(() => {
      return monthOptions.find((month) => month.value === preset);
    });
  };

  const ITEM_HEIGHT = 48;

  return (
    <>
      {cardLoader ? (
        isExporting ? null : (
          <LocalSeoCommonLoader />
        )
      ) : (isMap !== 3 && !cardReviewLoader) || isProgressing ? (
        <Card sx={{ ...keywordOverviewCss?.card, pb: 0 }}>
          <CardContent
            sx={{
              paddingBottom: '0px !important',
              ...keywordOverviewCss?.cardContent
            }}
          >
            <>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexWrap: { xs: 'wrap', sm: 'nowrap' },
                  gap: { xs: '12px', sm: '0px' }
                }}
              >
                <Box sx={LocalSeoAllSx?.avatarBoxSx}>
                  <Typography
                    sx={{
                      fontFamily: 'Inter',
                      fontWeight: 680,
                      fontSize: '28px',
                      lineHeight: '26px',
                      color: '#120242'
                    }}
                  >
                    {isPdfBuilder
                      ? 'Business Profile'
                      : 'Business Profile Dashboard'}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    gap: 2,
                    alignItems: 'center',
                    flexWrap: { xs: 'wrap', md: 'nowrap' }
                  }}
                >
                  {/* Business Name Filter */}
                  <BusinessProfileSelector
                    selectedAddress={selectedAddress}
                    locations={reduxFilteredLocationsData}
                    isEnterprise={isEnterprise}
                    enterpriseLimit={enterpriseDropdownBusinessesLimit}
                    onSelect={handleSelect}
                    onAddProfile={() => {
                      if (locationListResponse?.limitExceeded) {
                        setShowBuyLocalSeoSlot(true);
                      } else {
                        openNewTab(paths?.googleBusiness);
                      }
                    }}
                    onViewAll={() => {
                      navigate(paths?.localSeoBusinessListRoute);
                    }}
                  />

                  {/* Time Range Filter  */}
                  {allCardData && monthOptions && !isProgressing && (
                    <>
                      <DateRangeButton
                        presets={monthOptions}
                        selectedOption={selectedMonth}
                        onApply={applyFilters}
                        schema={''}
                        resolvePresetRange={(preset) => {
                          return getPresetRange(preset);
                        }}
                      />
                    </>
                  )}

                  <>
                    <Button
                      variant="outlined"
                      endIcon={
                        openMore ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />
                      }
                      onClick={handleClick}
                      sx={{
                        fontFamily: 'Inter !important',
                        height: '40px',
                        backgroundColor: '#120242',
                        color: '#FFFFFF',
                        '&:hover': {
                          backgroundColor: '#120242',
                          color: '#FFFFFF'
                        },
                        '&.Mui-disabled': {
                          backgroundColor: 'lightgray',
                          color: '#FFFFFF',
                          opacity: 0.5
                        }
                      }}
                      disableElevation
                      disabled={isProgressing}
                    >
                      {localSeoTexts?.actions}
                    </Button>
                    <Menu
                      sx={{
                        '& .MuiPaper-root': {
                          borderRadius: '4px',
                          boxShadow: '0px 0px 12px 2px rgba(0,0,0,0.06)'
                        }
                      }}
                      id="long-menu"
                      anchorEl={anchorElMore}
                      open={openMore}
                      onClose={handleClose}
                      MenuListProps={{
                        style: {
                          maxHeight: ITEM_HEIGHT * 6.7,
                          paddingTop: '6px',
                          paddingBottom: '6px'
                        }
                      }}
                      disableScrollLock={true}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right'
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          setOpenMonitoringModal(true);
                          handleClose();
                        }}
                        key={1}
                        disabled={showLocalMap === 0 || selectedAddress?.isDelete === true}
                      >
                        <Typography
                          sx={websiteAuditAfterLinearBar.scanWebpageSx}
                        >
                          {localSeoTexts?.rankTrackingFrequency}
                        </Typography>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          navigate(paths?.localTasks);
                          handleClose();
                        }}
                        key={2}
                      >
                        <Typography
                          sx={websiteAuditAfterLinearBar.scanWebpageSx}
                        >
                          {localSeoTexts?.viewSEOTasks}
                        </Typography>
                      </MenuItem>

                      <MenuItem
                        onClick={() => {
                          setOpenDeleteProfileModal(true);
                          handleClose();
                        }}
                        key={5}
                      >
                        <Typography sx={websiteAuditAfterLinearBar.deleteAudit}>
                          {localSeoTexts?.deleteProfile}
                        </Typography>
                      </MenuItem>
                    </Menu>
                  </>
                </Box>
              </Box>
              {!isProgressing && (
                <Box
                  className="LocalSeoPerformanceMetricsRow keep-together"
                  sx={{
                    display: isExporting ? 'flex' : { xs: 'grid', md: 'flex' },
                    flexWrap: isExporting ? 'nowrap' : undefined,
                    gap: '16px',
                    width: '100%',
                    marginTop: '24px'
                  }}
                >
                  {cardLoader ? (
                    <Box
                      sx={{
                        ...KeywordOverviewResultCardsCss?.subBoxes
                      }}
                    >
                      <Box>
                        <Skeleton
                          variant="rectangular"
                          animation="wave"
                          height={20}
                          sx={keywordOverviewCss?.cardSkeleton}
                        />
                        <Skeleton
                          variant="rectangular"
                          animation="wave"
                          height={20}
                          sx={keywordOverviewCss?.cardSkeleton}
                        />
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      className="LocalSeoSubCard"
                      sx={{
                        borderRadius: '6px',
                        padding: '16px',
                        border: '1px solid rgb(208, 213, 221)',
                        width: isExporting ? 0 : '100%',
                        flex: isExporting ? '1 1 0%' : undefined,
                        minWidth: isExporting ? 0 : undefined,
                        overflow: isExporting ? 'hidden' : undefined,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Box>
                        <Box
                          sx={{
                            justifyContent: 'space-between',
                            ...KeywordTrackingResultCss?.subBoxHeader
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'Inter',
                              fontWeight: 680,
                              fontSize: '20px',
                              lineHeight: '24px',
                              color: '#120242'
                            }}
                          >
                            {'Сalls'}
                          </Typography>
                          <CustomTooltip
                            title={
                              <Box>
                                <Typography
                                  sx={
                                    keywordResearchDashBoardCss?.customTollTipText
                                  }
                                >
                                  {
                                    'The number of people who clicked the "Call" button on a business’s Google profile during the selected time period.'
                                  }
                                </Typography>
                              </Box>
                            }
                            placement="bottom"
                            arrow
                          >
                            <HelpIcon
                              sx={KeywordOverviewResultCardsCss?.helpIcon}
                            />
                          </CustomTooltip>
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontFamily: 'Inter',
                              fontWeight: 700,
                              fontSize: '30px',
                              lineHeight: '38px',
                              color: '#120242',
                              marginTop: '8px',
                              display: 'inline-block'
                            }}
                          >
                            {allCardData?.totalCalls ?? '-'}
                          </Typography>
                          <Box
                            sx={{
                              display: 'inline-block',
                              marginLeft: '8px'
                            }}
                          >
                            {getCompareScoreJSX(
                              parseFloat(allChangesData?.totalCalls)
                            )}
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{ width: '100%', height: '100px' }}>
                        <ResponsiveContainer>
                          <AreaChart
                            data={callsGraphData || []}
                            margin={{ top: 0, right: 0, left: 0, bottom: 0 }} // Removes padding on all sides
                          >
                            {/* Define the equivalent linear gradient */}
                            <defs>
                              <linearGradient
                                id="customGradientCalls"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                              >
                                {/* Solid green at the bottom */}
                                <stop
                                  offset="70%"
                                  stopColor={
                                    getTrendColors(allChangesData?.totalCalls)
                                      .stop1
                                  }
                                  stopOpacity={1}
                                />
                                {/* Transparent green at the top */}
                                <stop
                                  offset="100%"
                                  stopColor={
                                    getTrendColors(allChangesData?.totalCalls)
                                      .stop2
                                  }
                                  stopOpacity={1}
                                />
                              </linearGradient>
                            </defs>
                            {/* Tooltip Configuration */}
                            <Tooltip
                              content={({ payload }) => {
                                if (payload && payload.length > 0) {
                                  const value = payload[0]?.value; // Get the clicked value
                                  return (
                                    <div
                                      style={{
                                        ...dataGraphsCss?.graphToolTipContent, // Apply custom styles
                                        padding: '5px'
                                      }}
                                    >
                                      <span
                                        style={dataGraphsCss?.graphToolTipLabel}
                                      >
                                        <b>Calls:</b> {value}
                                      </span>
                                    </div>
                                  );
                                }
                                return null;
                              }}
                              cursor={dataGraphsCss?.graphTooltipCursor}
                            />

                            {/* Area Chart */}
                            <Area
                              type="monotone"
                              dataKey="clicks" // Replace with the correct key from your data
                              stroke={
                                getTrendColors(allChangesData?.totalCalls)
                                  .stroke
                              }
                              fill="url(#customGradientCalls)"
                            />
                          </AreaChart>
                        </ResponsiveContainer>
                      </Box>
                    </Box>
                  )}
                  {cardLoader ? (
                    <Box
                      sx={{
                        ...KeywordOverviewResultCardsCss?.subBoxes
                      }}
                    >
                      <Box>
                        <Skeleton
                          variant="rectangular"
                          animation="wave"
                          height={20}
                          sx={keywordOverviewCss?.cardSkeleton}
                        />
                        <Skeleton
                          variant="rectangular"
                          animation="wave"
                          height={20}
                          sx={keywordOverviewCss?.cardSkeleton}
                        />
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      className="LocalSeoSubCard"
                      sx={{
                        borderRadius: '6px',
                        padding: '16px',
                        border: '1px solid rgb(208, 213, 221)',
                        width: isExporting ? 0 : '100%',
                        flex: isExporting ? '1 1 0%' : undefined,
                        minWidth: isExporting ? 0 : undefined,
                        overflow: isExporting ? 'hidden' : undefined,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Box>
                        <Box
                          sx={{
                            justifyContent: 'space-between',
                            ...KeywordTrackingResultCss?.subBoxHeader
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'Inter',
                              fontWeight: 680,
                              fontSize: '20px',
                              lineHeight: '24px',
                              color: '#120242',
                              width: 'max-content'
                            }}
                          >
                            {'Direction Requests'}
                          </Typography>
                          <CustomTooltip
                            title={
                              <Box>
                                <Typography
                                  sx={
                                    keywordResearchDashBoardCss?.customTollTipText
                                  }
                                >
                                  {
                                    'The number of times someone clicked "Directions" on a Google profile. This shows how many people were interested in where the business is and may have planned a visit.'
                                  }
                                </Typography>
                              </Box>
                            }
                            placement="bottom"
                            arrow
                          >
                            <HelpIcon
                              sx={KeywordOverviewResultCardsCss?.helpIcon}
                            />
                          </CustomTooltip>
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontFamily: 'Inter',
                              fontWeight: 700,
                              fontSize: '30px',
                              lineHeight: '38px',
                              color: '#120242',
                              marginTop: '8px',
                              display: 'inline-block'
                            }}
                          >
                            {allCardData?.totalDirectionRequests ?? '-'}
                          </Typography>
                          <Box
                            sx={{
                              display: 'inline-block',
                              marginLeft: '8px'
                            }}
                          >
                            {getCompareScoreJSX(
                              parseFloat(allChangesData?.totalDirectionRequests)
                            )}
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{ width: '100%', height: '100px' }}>
                        <ResponsiveContainer>
                          <AreaChart
                            data={directionGraphData || []}
                            margin={{ top: 0, right: 0, left: 0, bottom: 0 }} // Removes padding on all sides
                          >
                            {/* Define the equivalent linear gradient */}
                            <defs>
                              <linearGradient
                                id="customGradientDirections"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                              >
                                {/* Solid green at the bottom */}
                                <stop
                                  offset="70%"
                                  stopColor={
                                    getTrendColors(
                                      allChangesData?.totalDirectionRequests
                                    ).stop1
                                  }
                                  stopOpacity={1}
                                />
                                {/* Transparent green at the top */}
                                <stop
                                  offset="100%"
                                  stopColor={
                                    getTrendColors(
                                      allChangesData?.totalDirectionRequests
                                    ).stop2
                                  }
                                  stopOpacity={1}
                                />
                              </linearGradient>
                            </defs>
                            {/* Tooltip Configuration */}
                            <Tooltip
                              content={({ payload }) => {
                                if (payload && payload.length > 0) {
                                  const value = payload[0]?.value; // Get the clicked value
                                  return (
                                    <div
                                      style={{
                                        ...dataGraphsCss?.graphToolTipContent, // Apply custom styles
                                        padding: '5px'
                                      }}
                                    >
                                      <span
                                        style={dataGraphsCss?.graphToolTipLabel}
                                      >
                                        <b>Direction Requests:</b> {value}
                                      </span>
                                    </div>
                                  );
                                }
                                return null;
                              }}
                              cursor={dataGraphsCss?.graphTooltipCursor}
                            />

                            {/* Area Chart */}
                            <Area
                              type="monotone"
                              dataKey="clicks" // Replace with the correct key from your data
                              stroke={
                                getTrendColors(
                                  allChangesData?.totalDirectionRequests
                                ).stroke
                              }
                              fill="url(#customGradientDirections)"
                            />
                          </AreaChart>
                        </ResponsiveContainer>
                      </Box>
                    </Box>
                  )}
                  {cardLoader ? (
                    <Box
                      sx={{
                        ...KeywordOverviewResultCardsCss?.subBoxes
                      }}
                    >
                      <Box>
                        <Skeleton
                          variant="rectangular"
                          animation="wave"
                          height={20}
                          sx={keywordOverviewCss?.cardSkeleton}
                        />
                        <Skeleton
                          variant="rectangular"
                          animation="wave"
                          height={20}
                          sx={keywordOverviewCss?.cardSkeleton}
                        />
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      className="LocalSeoSubCard"
                      sx={{
                        borderRadius: '6px',
                        padding: '16px',
                        border: '1px solid rgb(208, 213, 221)',
                        width: isExporting ? 0 : '100%',
                        flex: isExporting ? '1 1 0%' : undefined,
                        minWidth: isExporting ? 0 : undefined,
                        overflow: isExporting ? 'hidden' : undefined,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Box>
                        <Box
                          sx={{
                            justifyContent: 'space-between',
                            ...KeywordTrackingResultCss?.subBoxHeader
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'Inter',
                              fontWeight: 680,
                              fontSize: '20px',
                              lineHeight: '24px',
                              color: '#120242'
                            }}
                          >
                            {'Clicks'}
                          </Typography>
                          <CustomTooltip
                            title={
                              <Box>
                                <Typography
                                  sx={
                                    keywordResearchDashBoardCss?.customTollTipText
                                  }
                                >
                                  {
                                    'How many times people clicked the website link from a Google Business Profile during the selected time period.'
                                  }
                                </Typography>
                              </Box>
                            }
                            placement="bottom"
                            arrow
                          >
                            <HelpIcon
                              sx={KeywordOverviewResultCardsCss?.helpIcon}
                            />
                          </CustomTooltip>
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              fontFamily: 'Inter',
                              fontWeight: 700,
                              fontSize: '30px',
                              lineHeight: '38px',
                              color: '#120242',
                              marginTop: '8px',
                              display: 'inline-block'
                            }}
                          >
                            {allCardData?.totalWebsiteClicks ?? '-'}
                          </Typography>
                          <Box
                            sx={{
                              display: 'inline-block',
                              marginLeft: '8px'
                            }}
                          >
                            {getCompareScoreJSX(
                              parseFloat(allChangesData?.totalWebsiteClicks)
                            )}
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{ width: '100%', height: '100px' }}>
                        <ResponsiveContainer>
                          <AreaChart
                            data={clicksGraphData || []}
                            margin={{ top: 0, right: 0, left: 0, bottom: 0 }} // Removes padding on all sides
                          >
                            {/* Define the equivalent linear gradient */}
                            <defs>
                              <linearGradient
                                id="customGradientClicks"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                              >
                                {/* Solid green at the bottom */}
                                <stop
                                  offset="70%"
                                  stopColor={
                                    getTrendColors(
                                      allChangesData?.totalWebsiteClicks
                                    ).stop1
                                  }
                                  stopOpacity={1}
                                />
                                {/* Transparent green at the top */}
                                <stop
                                  offset="100%"
                                  stopColor={
                                    getTrendColors(
                                      allChangesData?.totalWebsiteClicks
                                    ).stop2
                                  }
                                  stopOpacity={1}
                                />
                              </linearGradient>
                            </defs>
                            {/* Tooltip Configuration */}
                            <Tooltip
                              content={({ payload }) => {
                                if (payload && payload.length > 0) {
                                  const value = payload[0]?.value; // Get the clicked value
                                  return (
                                    <div
                                      style={{
                                        ...dataGraphsCss?.graphToolTipContent, // Apply custom styles
                                        padding: '5px'
                                      }}
                                    >
                                      <span
                                        style={dataGraphsCss?.graphToolTipLabel}
                                      >
                                        <b>Clicks:</b> {value}
                                      </span>
                                    </div>
                                  );
                                }
                                return null;
                              }}
                              cursor={dataGraphsCss?.graphTooltipCursor}
                            />

                            {/* Area Chart */}
                            <Area
                              type="monotone"
                              dataKey="clicks" // Replace with the correct key from your data
                              stroke={
                                getTrendColors(
                                  allChangesData?.totalWebsiteClicks
                                ).stroke
                              }
                              fill="url(#customGradientClicks)"
                            />
                          </AreaChart>
                        </ResponsiveContainer>
                      </Box>
                    </Box>
                  )}
                  {cardLoader ? (
                    <Box
                      sx={{
                        ...KeywordOverviewResultCardsCss?.subBoxes
                      }}
                    >
                      <Box>
                        <Skeleton
                          variant="rectangular"
                          animation="wave"
                          height={20}
                          sx={keywordOverviewCss?.cardSkeleton}
                        />
                        <Skeleton
                          variant="rectangular"
                          animation="wave"
                          height={20}
                          sx={keywordOverviewCss?.cardSkeleton}
                        />
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      className="LocalSeoSubCard"
                      sx={{
                        borderRadius: '6px',
                        padding: '16px',
                        border: '1px solid rgb(208, 213, 221)',
                        width: isExporting ? 0 : '100%',
                        flex: isExporting ? '1 1 0%' : undefined,
                        minWidth: isExporting ? 0 : undefined,
                        overflow: isExporting ? 'hidden' : undefined,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Box
                        sx={{
                          justifyContent: 'space-between',
                          ...KeywordTrackingResultCss?.subBoxHeader
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: 'Inter',
                            fontWeight: 680,
                            fontSize: '20px',
                            lineHeight: '24px',
                            color: '#120242'
                          }}
                        >
                          {'Avg Rating'}
                        </Typography>
                        <CustomTooltip
                          title={
                            <Box>
                              <Typography
                                sx={
                                  keywordResearchDashBoardCss?.customTollTipText
                                }
                              >
                                {
                                  'The average star score a business has on Google, out of 5.'
                                }
                              </Typography>
                            </Box>
                          }
                          placement="bottom"
                          arrow
                        >
                          <HelpIcon
                            sx={KeywordOverviewResultCardsCss?.helpIcon}
                          />
                        </CustomTooltip>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'baseline',
                          gap: '16px'
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{
                              fontFamily: 'Inter',
                              fontWeight: 700,
                              fontSize: '30px',
                              lineHeight: '38px',
                              color: '#120242',
                              marginTop: '8px',
                              display: 'inline-block'
                            }}
                          >
                            {totalReviewsRating ?? ''}
                            {totalReviews !== 0 && (
                              <span
                                style={{
                                  fontSize: '16px'
                                }}
                              >
                                {totalReviewsRating
                                  ? `(${totalReviews})` || ''
                                  : ''}
                              </span>
                            )}
                          </Typography>
                          <Box
                            sx={{
                              display: 'inline-block',
                              marginLeft: '8px'
                            }}
                          >
                            {getCompareScoreJSX(
                              parseFloat(allChangesData?.reviews)
                            )}
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          marginTop: '8px'
                        }}
                      >
                        {ratingData?.map((item, idx) => (
                          <Box
                            key={idx}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              mb: '4px'
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily: 'Inter',
                                fontWeight: 400,
                                fontSize: '14px',
                                lineHeight: '20px',
                                color: '#120242',
                                minWidth: '60px'
                              }}
                            >
                              {' '}
                              {item?.value || ''}{' '}
                            </Typography>
                            <LinearProgress
                              variant="determinate"
                              value={item?.per ? parseFloat(item?.per) : 0}
                              sx={{
                                width: '100%',
                                bgcolor: '#D1F5EE',
                                height: 8,
                                borderRadius: 32
                              }}
                              color="secondary"
                            />
                            <Typography
                              sx={{
                                fontFamily: 'Inter',
                                fontWeight: 600,
                                fontSize: '14px',
                                lineHeight: '20px',
                                color: '#120242',
                                minWidth: '32px'
                              }}
                            >
                              {' '}
                              {item?.per || 0}{' '}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  )}
                </Box>
              )}
            </>

            {
              <LocalSeoMapDashBoard
                setReviewCardLoader={setReviewCardLoader}
                cardReviewLoader={cardReviewLoader}
                setIsProgressing={setIsProgressing}
                isExporting={isExporting}
                isPdfBuilder={isPdfBuilder}
              />
            }
          </CardContent>
        </Card>
      ) : (
        <>
          <LocalSeoMapDashBoard
            setReviewCardLoader={setReviewCardLoader}
            cardReviewLoader={cardReviewLoader}
            setIsProgressing={setIsProgressing}
            isExporting={isExporting}
            isPdfBuilder={isPdfBuilder}
          />
        </>
      )}
      <CommonModal
        open={openMonitoringModal}
        handCloseModal={handleCloseMonitoringModal}
        title={''}
        closebtn={false}
        isAgencyModal={true}
        isInfoModal={true}
        isFreeDowngrade={true}
        isDynamicWidth={'488px'}
      >
        <TrackingFrequency handleClose={handleCloseMonitoringModal} />
      </CommonModal>
      <CommonModal
        open={openDeleteProfileModal}
        handCloseModal={handleCloseDeleteProfileModal}
        title={''}
        closebtn={false}
        isAgencyModal={true}
        isInfoModal={true}
        isFreeDowngrade={true}
        isDynamicWidth={'488px'}
      >
        <DeleteProfileModal handleClose={handleCloseDeleteProfileModal} />
      </CommonModal>
      {showBuyLocalSeoSlot && (
        <BuySlotsCommonModal
          triggerOpen={true}
          onClose={() => setShowBuyLocalSeoSlot(false)}
          isLocalSeo={true}
        />
      )}
      <CommonModal
        open={openDisconnectedModal}
        handCloseModal={handleCloseDisconnectSiteModal}
        title={disconnectedModalTexts?.header}
        closebtn={true}
      >
        <DisconnectedModal
          handleCloseDisconnectSiteModal={handleCloseDisconnectSiteModal}
          isLocalSeo={true}
        />
      </CommonModal>
    </>
  );
};
